import { useSelector } from "react-redux";
import { authSelector } from "../reducers";
import { Navigate, Outlet } from "react-router";
import LoadingCentered from "../common/loaders/loadingcentered"

export const ProtectedRoute = () => {
  const auth = useSelector(authSelector);
  const hasRefreshToken = typeof sessionStorage !== "undefined" && !!sessionStorage.getItem("esalary-refresh")

  // Restoring session from refresh token - stay on current URL, show loading
  if (!auth && hasRefreshToken) {
    return <LoadingCentered show />
  }

  // Not authenticated and no refresh token → redirect to login
  if (!auth || auth.mfaRequired) {
    return <Navigate to="/" replace />;
  }

  // Authenticated → render child routes
  return <Outlet />;
};
